import PropTypes from "prop-types";
import styles from "components/stay/HeroGraphic.module.scss";

/**
 * @param {string} svgSrc - Url for svg graphic
 * @param {string} alt - Alt text for graphic
 */

export default function HeroGraphic({ svgSrc, alt }) {
  return (
    <div className={styles.component}>
      <img alt={alt} className={styles.graphic} src={svgSrc} />
    </div>
  );
}

HeroGraphic.propTypes = {
  svgSrc: PropTypes.string.isRequired,
  alt: PropTypes.string,
};
